<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <h4>{{ $t('Menu.list.widths.width') }}</h4>
      </div>
    </div>
    <div class="row border-bottom">
      <div class="col-6 text-start">
        <img :src="appUrl + '/img/assets/lengths/ketten_laenge.jpg'" :srcset="appUrl + '/img/assets/lengths/ketten_laenge@2x.jpg'">
      </div>
      <div class="col-6">
        <select class="form-control" @change="changeItem($event.target.value)" v-if="typeof possibleItems.list == 'object'">
          <option v-for="(item, index) in possibleItems.list" v-bind:key="index" :selected="item.match" :value="index">{{ item.text }} mm</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
  import Config from "@/vuex/Config";

  export default {
    name: 'VariationsChainWidths',
    props: [
      'possibleItems'
    ],
    data() {
      return {
        appUrl: Config.getters.getAppUrl,
      }
    },
    methods: {
      changeItem: function (id) {
        let item = this.possibleItems.list[id];
        this.$parent.$parent.changeItem(item.itemnumber, item.alerts);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #app {
    h4 {
      font-weight: bold;
      font-size: 1em;
      margin-bottom: 1.5em;
    }

    .border-bottom {
      padding-bottom: 1em;
      margin-bottom: 1em;
      border-bottom: solid 0.1em $borderColor;
    }

    select {
      margin-top: 1.4em;
    }

    img {
      display: block;
      width: 5em;
      height: 5em;
      border-radius: 5em;
      border: solid 0.1rem $brandDarkGrey;
      margin-bottom: 0.5em;
    }
  }
</style>
